export default "__VITE_ASSET__CBfh3SLY__"